import client from '../client';
import axios from 'axios';
/**
 * Safely executes a GET request handling both legacy jQuery serialized strings
 * and modern JavaScript objects for parameters.
 */
export const safeGet = (url, params = {}) => {
    if (typeof params === 'string') {
        const separator = url.includes('?') ? '&' : '?';
        const cleanParams = params.startsWith('?') ? params.substring(1) : params;
        return client.get(`${url}${cleanParams ? separator + cleanParams : ''}`);
    }
    return client.get(url, { params });
};
/**
 * Removes null, empty strings, and empty arrays from filter payloads
 * so we don't send clutter query parameters (e.g., ?search=&status=)
 */
export const sanitizeFilters = (filters) => {
    return Object.fromEntries(Object.entries(filters).filter(([_, value]) => {
        if (Array.isArray(value))
            return value.length > 0;
        return value !== null && value !== '' && value !== undefined;
    }));
};
/**
 * Safely extracts a human-readable error message from caught exceptions.
 * Handles Axios HTTP errors (including Laravel backend validation messages),
 * standard JavaScript Errors, and unknown fallbacks.
 */
export function getErrorMessage(err, fallbackMessage = 'An unexpected error occurred.') {
    if (axios.isAxiosError(err)) {
        // Check for standard Laravel backend error message
        const message = err.response?.data?.message || err.response?.data?.error;
        if (typeof message === 'string' && message.trim() !== '') {
            return message;
        }
        // Check for Laravel validation errors array/object (422 Unprocessable Content)
        const errors = err.response?.data?.errors;
        if (errors && typeof errors === 'object') {
            const firstKey = Object.keys(errors)[0];
            const firstError = errors[firstKey];
            if (Array.isArray(firstError) && firstError.length > 0) {
                return firstError[0];
            }
        }
        // Fallback to HTTP status text (e.g., "Unauthorized", "Forbidden", "Not Found")
        if (err.response?.statusText) {
            return `Error ${err.response.status}: ${err.response.statusText}`;
        }
    }
    // Standard native JavaScript Error instance (e.g., SyntaxError, TypeError)
    if (err instanceof Error && err.message) {
        return err.message;
    }
    return fallbackMessage;
}
